import { Box, Typography, Grid, CircularProgress, Divider, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { Formik, Form, FieldArray } from 'formik';
import * as Yup from 'yup';
import { ClearRounded, SaveRounded } from "@mui/icons-material";
import CustomButton from "../../common/CustomButton";
import CustomTextField from "../../common/CustomTextField";
import CustomTextarea from "../../common/CustomTextarea";
import axios from 'axios';
import React, { useState, useEffect } from "react";
import { UPDATE_PROFORMA_INVOICE_EXPORT, READ_PROFORMA_INVOICE_EXPORT, DELETE_PROFORMA_INVOICE_PARTICULAR_EXPORT } from '../../../services/apiRoutes';
import AssignmentLateOutlinedIcon from '@mui/icons-material/AssignmentLateOutlined';
import AddRounded from '@mui/icons-material/AddRounded';
import Card from '@mui/material/Card';
import CustomAutocomplete from '../../common/CustomAutoComplete';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CustomStyle from '../../common/CustomStyle';
import CustomPrefixSuffixField from '../../common/CustomPrefixSuffixField';
import CustomDelete from '../../common/CustomDeleteAlert';
import { t } from '../../../constants/translationHelper';

const ValidationSchema = Yup.object().shape({
    customerNamesId: Yup.number().required("Customer Name is required"),
    proformaInvoiceNo: Yup.string().required("Proforma Invoice No. is required"),
    date: Yup.string().required("Date is required"),
    dueDate: Yup.string().required("Due Date is required"),
    particulars: Yup.array()
        .of(
            Yup.object().shape({
                particularName: Yup.string().required("Particular is required"),
                qty: Yup.number().required("Quantity is required"),
                rate: Yup.number().required("Rate is required"),
                amount: Yup.number().required("amount is required"),
                unit: Yup.string().required("Unit is required"),
            })
        )
        .required("Particulars are required"),
});

const UpdateExpProformInv = ({ handleClose, setMessage, currencyList, portMasters, paymentMethod, paymentAgainst, fetchData, proformaInvExpId, customerList, productsList, expProformaPrefix, expProformaSuffix }) => {
    const [data, setData] = useState(null);
    const [currencySymbol, setCurrencySymbol] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [deleteAlert, setDeleteAlert] = useState(false)
    const [rowId, setRowId] = useState('')

    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true)
        setRowId(rowId)
    }

    const fetchProformaInvoiceData = async () => {
        if (!proformaInvExpId) return;

        try {
            setLoading(true);
            const accessToken = sessionStorage.getItem('accessToken');
            const response = await axios.get(READ_PROFORMA_INVOICE_EXPORT(proformaInvExpId), {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            const currencySymbol = response?.data?.data?.currency?.currency_symbol || '';
            setCurrencySymbol(currencySymbol);
            setData(response.data.data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    // Call this function wherever needed
    useEffect(() => {
        fetchProformaInvoiceData();
    }, [proformaInvExpId]);


    if (loading) return <CircularProgress />;
    if (error) return <p>Error: {error}</p>;

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const accessToken = sessionStorage.getItem('accessToken');
            const response = await axios.put(UPDATE_PROFORMA_INVOICE_EXPORT(proformaInvExpId), values, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (response.status === 200) {
                setMessage({
                    open: true,
                    text: response.data.message || "Proforma Invoice updated successfully",
                    type: "success",
                });
                fetchData();
                setTimeout(() => {
                    handleClose();
                }, 500);
            } else {
                alert('Something went wrong');
            }
        } catch (error) {
            alert('Something went wrong');
        } finally {
            setSubmitting(false);
        }
    };
    const handleDelete = async (proformaParticularsExpId) => {
        setLoading(true);
        const authToken = sessionStorage.getItem('accessToken');

        try {
            const response = await axios.delete(DELETE_PROFORMA_INVOICE_PARTICULAR_EXPORT(proformaParticularsExpId), {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });
            if (response.status === 200) {
                setMessage({
                    open: true,
                    text: "deleted successfully",
                    type: "success",
                });
                fetchProformaInvoiceData();
                setDeleteAlert(false);

            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);

            if (error.response) {
                if (error.response.status === 409) {
                    setMessage({
                        open: true,
                        text: error.response.data?.error || "Cannot delete Data. Related Shipment exists.",
                        type: "error",
                    });
                } else {
                    setMessage({
                        open: true,
                        text: "An error occurred while deleting the Data.",
                        type: "error",
                    });
                }
            } else {
                console.error("Error deleting Data", error);
                setMessage({
                    open: true,
                    text: "Network error. Please try again later.",
                    type: "error",
                });
            }
        }
    };



    return (
        <>
            <Box sx={{ mx: 'auto', mt: 0 }}>
                <Formik
                    initialValues={{
                        customerNamesId: data?.customerNamesId || '',
                        reference: data?.reference || '',
                        proformaInvoiceNo: data?.proformaInvoiceNo || '',
                        currencyId: parseInt(data?.currencyId || ''),
                        date: data?.date || '',
                        dueDate: data?.dueDate || '',
                        note: data?.note || '',

                        paymentType: parseInt(data?.paymentType || ''),
                        advance: data?.advance || '',
                        final: data?.final || '',
                        selectAagainst: parseInt(data?.selectAagainst || ''),
                        creditDay: data?.creditDay || '',
                        portOfLoading: parseInt(data?.portOfLoading || ''),
                        portOfDestination: parseInt(data?.portOfDestination || ''),
                        particulars: data.particulars.map(particular => ({
                            proformaParticularsExpId: particular.proformaParticularsExpId,
                            particularName: parseInt(particular.particularName,),
                            qty: particular.qty,
                            rate: parseFloat(particular.rate).toFixed(2),
                            amount: parseFloat(particular.amount).toFixed(2),
                            unit: parseInt(particular.unit,),
                            description: particular.description,
                        }))
                    }}
                    validationSchema={ValidationSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {({ isSubmitting, errors, touched, handleChange, setFieldValue, values }) => (
                        <Form>
                            <Grid container spacing={1} style={CustomStyle.container}>
                                <Grid item xs={4} md={4}>
                                    <Typography sx={{ fontWeight: 600 }} style={CustomStyle.title}>
                                        {t("Update Proforma Invoice")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={8} md={8} style={CustomStyle.buttonContainer}>
                                    <Box style={CustomStyle.buttonBox}>
                                        <CustomButton
                                            startIcon={<SaveRounded />}
                                            title={isSubmitting ? <CircularProgress size={20} color="inherit" /> : "Save"}
                                            size="small"
                                            variant="contained"
                                            type="submit"
                                            disabled={isSubmitting}
                                        />
                                        <CustomButton
                                            startIcon={<ClearRounded />}
                                            title="Cancel"
                                            size="small"
                                            variant="contained"
                                            onClick={handleClose}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                            <Divider />
                            <Grid container spacing={1} sx={{ px: "0%" }}>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Box display="flex" flexDirection="row" alignItems="center">
                                        <InsertDriveFileOutlinedIcon />
                                        <Typography style={{ fontWeight: 700, color: "#212529", fontSize: "16px", marginLeft: "4px" }}>
                                            {t("Bill To")}
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <CustomAutocomplete
                                        options={customerList}
                                        fieldLabel="Customer Name"
                                        required={true}
                                        readOnly={true}
                                        getOptionLabel={(option) => option.title}
                                        value={customerList.find((option) => option.id === values.customerNamesId) || null}
                                        onChange={(e, newValue) =>
                                            setFieldValue('customerNamesId', newValue ? newValue.id : '')
                                        }
                                        placeholder="Enter Supplier Name"
                                        error={touched.customerNamesId && !!errors.customerNamesId}
                                        helperText={touched.customerNamesId && errors.customerNamesId}
                                        sx={{
                                            backgroundColor: "#E9ECEF"
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <CustomTextField
                                        placeholder="Enter Reference"
                                        name="reference"
                                        fieldLabel="Reference"
                                        value={values.reference}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>

                                    <CustomPrefixSuffixField
                                        placeholder="Enter Proforma Invoice No."
                                        name="proformaInvoiceNo"
                                        fieldLabel="Proforma Invoice No."
                                        required={true}
                                        value={values.proformaInvoiceNo}
                                        onChange={handleChange}
                                        error={touched.proformaInvoiceNo && !!errors.proformaInvoiceNo}
                                        helperText={touched.proformaInvoiceNo && errors.proformaInvoiceNo}
                                        sx={CustomStyle.readOnly}
                                        readOnly={true}
                                        prefix={expProformaPrefix}
                                        suffix={expProformaSuffix}
                                    />

                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <CustomTextField
                                        placeholder="Enter Date"
                                        type="date"
                                        name="date"
                                        fieldLabel="Date"
                                        value={values.date}
                                        onChange={handleChange}
                                        required={true}

                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <CustomTextField
                                        placeholder="Enter Due Date"
                                        type="date"
                                        name="dueDate"
                                        fieldLabel="Due Date"
                                        required={true}
                                        value={values.dueDate}
                                        onChange={handleChange}
                                        error={touched.dueDate && !!errors.dueDate}
                                        helperText={touched.dueDate && errors.dueDate}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <CustomAutocomplete
                                        options={currencyList}
                                        fieldLabel="Currency"
                                        required={true}
                                        getOptionLabel={(option) => option.title}
                                        value={currencyList.find((option) => option.id === values.currencyId) || null}
                                        onChange={(e, newValue) =>
                                            setFieldValue('currencyId', newValue ? newValue.id : '')
                                        }
                                        placeholder="Select Currency"
                                        sx={CustomStyle.readOnly}
                                        readOnly={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <CustomAutocomplete
                                        options={paymentMethod}
                                        fieldLabel="payment Type"
                                        required={true}
                                        getOptionLabel={(option) => option.title}
                                        value={paymentMethod.find((option) => option.id === values.paymentType) || null}
                                        onChange={(e, newValue) => {
                                            setFieldValue('paymentType', newValue ? newValue.id : '');
                                            setFieldValue('advance', '');
                                            setFieldValue('final', '');
                                            setFieldValue('selectAagainst', '');
                                            setFieldValue('creditDay', '');
                                        }}
                                        placeholder="Payment payment Type"
                                    />
                                </Grid>

                                {values.paymentType === 1 && (
                                    <>
                                        <Grid item xs={12} md={2}>
                                            <CustomPrefixSuffixField
                                                suffix='%'
                                                placeholder="Enter advance"
                                                name="advance"
                                                fieldLabel="Advance"
                                                value={values.advance}
                                                onChange={handleChange}
                                                type="number"
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <CustomPrefixSuffixField
                                                suffix='%'
                                                placeholder="Enter final"
                                                name="final"
                                                fieldLabel="Final"
                                                value={values.final}
                                                onChange={handleChange}
                                                type="number"
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <CustomAutocomplete
                                                options={paymentAgainst}
                                                fieldLabel="select Aagainst"
                                                getOptionLabel={(option) => option.title}
                                                value={paymentAgainst.find((option) => option.id === values.selectAagainst) || null}
                                                onChange={(e, newValue) => {
                                                    setFieldValue('selectAagainst', newValue ? newValue.id : '');
                                                    setFieldValue('creditDay', '');
                                                }}
                                                placeholder="select Aagainst "
                                            />
                                        </Grid>
                                        {values.selectAagainst === 2 && (
                                            <Grid item xs={12} md={2}>
                                                <CustomTextField
                                                    placeholder="Enter credit days"
                                                    name="creditDay"
                                                    fieldLabel="Credit Day"
                                                    value={values.creditDay}
                                                    onChange={handleChange}
                                                    type="number"
                                                />
                                            </Grid>
                                        )}
                                    </>
                                )}

                                {values.paymentType === 2 && (
                                    <>
                                        <Grid item xs={12} md={2}>
                                            <CustomPrefixSuffixField
                                                suffix='%'
                                                placeholder="Enter advance"
                                                name="advance"
                                                fieldLabel="Advance"
                                                value={values.advance}
                                                onChange={handleChange}
                                                type="number"
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <CustomPrefixSuffixField
                                                suffix='%'
                                                placeholder="Enter against LC"
                                                name="final"
                                                fieldLabel="against LC"
                                                value={values.final}
                                                onChange={handleChange}
                                                type="number"
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <CustomTextField
                                                placeholder="Enter credit days"
                                                name="creditDay"
                                                fieldLabel="Credit Day"
                                                value={values.creditDay}
                                                onChange={handleChange}
                                                type="number"
                                            />
                                        </Grid>

                                    </>
                                )}
                                <Grid item xs={12} md={6}>
                                    <CustomAutocomplete
                                        options={portMasters}
                                        fieldLabel="Port Of Loading"
                                        getOptionLabel={(option) => option.title}
                                        value={portMasters.find((option) => option.id === values.portOfLoading) || null}
                                        onChange={(e, newValue) =>
                                            setFieldValue('portOfLoading', newValue ? newValue.id : '')
                                        }
                                        placeholder="Select Port Of Loading"

                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <CustomAutocomplete
                                        options={portMasters}
                                        fieldLabel="Port Of Destination"
                                        getOptionLabel={(option) => option.title}
                                        value={portMasters.find((option) => option.id === values.portOfDestination) || null}
                                        onChange={(e, newValue) =>
                                            setFieldValue('portOfDestination', newValue ? newValue.id : '')
                                        }
                                        placeholder="Select Port Of Destination"
                                    />
                                </Grid>

                            </Grid>
                            <FieldArray
                                name="particulars"
                                render={arrayHelpers => (
                                    <>
                                        <Grid item xs={12}>
                                            <Grid item xs={12} md={6}>
                                                <Box display="flex" flexDirection="row" alignItems="center">
                                                    <AssignmentLateOutlinedIcon />
                                                    <Typography style={{ fontWeight: 700, color: "#212529", fontSize: "16px", marginLeft: "4px" }}>
                                                        {t("Particulars")}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Box style={{ overflowX: 'auto', overflowY: 'auto' }}>
                                                <Table style={{ width: "100%" }}>
                                                    <TableHead>
                                                        <TableRow style={{ height: '40px', backgroundColor: "#e7f0f7" }}>
                                                            <TableCell style={{ ...styles.tablecell, width: "50px" }} rowSpan={2}>{t("No.")}</TableCell>
                                                            <TableCell style={{ ...styles.tablecell, width: "300px" }} rowSpan={2}>{t("Particular")}</TableCell>
                                                            <TableCell style={{ ...styles.tablecell, width: "100px" }} rowSpan={2}>{t("Qty")}</TableCell>
                                                            <TableCell style={{ ...styles.tablecell, width: "100px" }} rowSpan={2}>{t("Rate")}</TableCell>
                                                            <TableCell style={{ ...styles.tablecell, width: "100px" }} rowSpan={2}>{t("Unit")}</TableCell>
                                                            <TableCell style={{ ...styles.tablecell, width: "100px" }} rowSpan={2}>{t("Amount")}</TableCell>
                                                            <TableCell style={{ ...styles.tablecell, width: "50px" }} rowSpan={2}>{t("Action")}</TableCell>
                                                        </TableRow>
                                                    </TableHead>

                                                    <TableBody>
                                                        {values.particulars.map((particular, index) => {
                                                            const handleQtyChange = (e) => {
                                                                const newQty = parseFloat(e.target.value);
                                                                setFieldValue(`particulars.${index}.qty`, newQty);
                                                                const newRate = parseFloat(particular.rate) || '';
                                                                const newAmount = (newQty * newRate).toFixed(2);
                                                                setFieldValue(`particulars.${index}.amount`, newAmount);
                                                            };
                                                            const handleRateChange = (e) => {
                                                                const newRate = parseFloat(e.target.value);
                                                                setFieldValue(`particulars.${index}.rate`, newRate);
                                                                const newQty = parseFloat(particular.qty) || '';
                                                                const newAmount = (newQty * newRate).toFixed(2);
                                                                setFieldValue(`particulars.${index}.amount`, newAmount);
                                                            };
                                                            return (
                                                                <TableRow key={index}>
                                                                    <TableCell style={styles.tablecell}>{index + 1}</TableCell>
                                                                    <TableCell style={styles.tablecell}>
                                                                        <CustomAutocomplete
                                                                            options={productsList || []}
                                                                            required={true}
                                                                            getOptionLabel={(option) => option.productName || ''}
                                                                            value={productsList?.find((option) => option.productsId === particular?.particularName) || null}
                                                                            onChange={(e, newValue) => {
                                                                                setFieldValue(`particulars.${index}.particularName`, newValue ? newValue.productsId : '');
                                                                                setFieldValue(`particulars.${index}.unit`, newValue ? newValue.productsUnit?.productsUnitId : '');
                                                                            }}
                                                                            placeholder="Select Product Name"
                                                                            error={touched.particulars?.[index]?.particularName && !!errors.particulars?.[index]?.particularName}
                                                                            helperText={touched.particulars?.[index]?.particularName && errors.particulars?.[index]?.particularName}
                                                                        />
                                                                        <CustomTextarea
                                                                            name={`particulars.${index}.description`}
                                                                            value={particular?.description || ''}
                                                                            onChange={handleChange}
                                                                            placeholder="Enter Description"
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell style={styles.tablecell}>
                                                                        <CustomTextField
                                                                            required={true}
                                                                            name={`particulars.${index}.qty`}
                                                                            type="number"
                                                                            value={particular.qty}
                                                                            onChange={handleQtyChange}
                                                                            placeholder="Qty"
                                                                            error={touched.particulars?.[index]?.qty && !!errors.particulars?.[index]?.qty}
                                                                            helperText={touched.particulars?.[index]?.qty && errors.particulars?.[index]?.qty}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell style={styles.tablecell}>
                                                                        <CustomTextField
                                                                            required={true}
                                                                            name={`particulars.${index}.rate`}
                                                                            type="number"
                                                                            value={particular.rate}
                                                                            onChange={handleRateChange}
                                                                            placeholder="Rate"
                                                                            error={touched.particulars?.[index]?.rate && !!errors.particulars?.[index]?.rate}
                                                                            helperText={touched.particulars?.[index]?.rate && errors.particulars?.[index]?.rate}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell style={styles.tablecell}>
                                                                        <CustomTextField
                                                                            required={true}
                                                                            readOnly={true}
                                                                            name={`particulars.${index}.unit`}
                                                                            value={productsList
                                                                                ?.find((option) => option.productsId === particular?.particularName)
                                                                                ?.productsUnit?.unitName || ''}
                                                                            onChange={(e) =>
                                                                                setFieldValue(`particulars.${index}.unit`, e.target.value)
                                                                            }
                                                                            placeholder="Unit"
                                                                            sx={{
                                                                                backgroundColor: "#E9ECEF"
                                                                            }}
                                                                            error={touched.particulars?.[index]?.unit && !!errors.particulars?.[index]?.unit}
                                                                            helperText={touched.particulars?.[index]?.unit && errors.particulars?.[index]?.unit}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell style={styles.tablecell}>
                                                                        <CustomTextField
                                                                            required={true}
                                                                            name={`particulars.${index}.amount`}
                                                                            type="number"
                                                                            value={particular.amount || ''}
                                                                            onChange={handleChange}
                                                                            placeholder="Amount"
                                                                            sx={{
                                                                                backgroundColor: "#E9ECEF"
                                                                            }}
                                                                            readOnly={true}
                                                                            error={touched.particulars?.[index]?.amount && !!errors.particulars?.[index]?.amount}
                                                                            helperText={touched.particulars?.[index]?.amount && errors.particulars?.[index]?.amount}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell style={styles.tablecell}>
                                                                        <DeleteOutlineOutlinedIcon
                                                                            onClick={() => handleOpenDeleteAlert(particular.proformaParticularsExpId)}
                                                                            style={{ color: '#E4003A', fontSize: "20px", cursor: "pointer" }}

                                                                        />
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        })}
                                                    </TableBody>

                                                    <TableRow style={{ height: '40px' }}>
                                                        <TableCell style={styles.tablecell} colSpan={7}>
                                                            <div style={{ margin: "auto", textAlign: "center" }}>
                                                                <CustomButton
                                                                    sx={Additemstyle}
                                                                    startIcon={<AddRounded />}
                                                                    title="Add Item"
                                                                    variant="contained"
                                                                    size="small"
                                                                    onClick={() => arrayHelpers.push({
                                                                        particular: '',
                                                                        qty: '',
                                                                        rate: '',
                                                                        unit: ''
                                                                    })}
                                                                />
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow style={{ height: '40px' }}>
                                                        <TableCell style={styles.tablecellfooter} colSpan={2}  > {t("Total")}</TableCell>
                                                        <TableCell style={styles.tablecellfooter}  >
                                                            {values.particulars
                                                                .reduce((total, particular) => total + (parseFloat(particular.qty) || 0), 0)
                                                            }                                                    </TableCell>

                                                        <TableCell style={styles.tablecellfooter} colSpan={2}  > </TableCell>
                                                        <TableCell style={styles.tablecellfooter} >
                                                            {currencySymbol} &nbsp;
                                                            {values.particulars
                                                                .reduce((total, particular) => total + ((particular.qty || 0) * (particular.rate || 0)), 0)
                                                                .toFixed(2)}
                                                        </TableCell>
                                                        <TableCell style={styles.tablecellfooter} > </TableCell>
                                                    </TableRow>
                                                </Table>
                                            </Box>
                                        </Grid>
                                    </>
                                )}
                            />
                            <Grid container spacing={1} style={{ paddingBottom: "5px", paddingTop: "10px" }}>
                                <Grid item xs={12} md={7}>
                                    <Typography style={{ fontWeight: 700, color: "#212529", fontSize: "16px" }}>
                                        {t("In Words")}
                                    </Typography>
                                    <Typography style={{ color: "#212529", fontWeight: 400, fontSize: "14px" }}>
                                        {t("Only")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    <div>
                                        <Box display="flex" flexDirection="row">
                                            <Box display="inline-flex" alignItems="center" pr={1}>
                                                {currencySymbol}
                                            </Box>
                                            <Box display="inline-flex" alignItems="center">
                                                <Typography style={{ fontWeight: 700, color: "#212529", fontSize: "16px" }}>
                                                    {t("Summary")}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Card variant="outlined" style={{ padding: "2px" }}>
                                            <Box
                                                display="flex"
                                                flexDirection="row"
                                                alignItems="center"
                                                justifyContent="space-between"
                                            >
                                                <Typography style={{ fontWeight: "600", fontSize: "15px", paddingLeft: "10px" }}>{t("Grand Total")}:</Typography>
                                                <CustomPrefixSuffixField
                                                    prefix={currencySymbol}


                                                    name="totalAmount"
                                                    value={values.particulars.reduce((total, particular) => total + ((particular.qty || 0) * (particular.rate || 0)), 0).toFixed(2)}
                                                    readOnly={true}
                                                    placeholder="Total Amount"
                                                    sx={{
                                                        backgroundColor: "#E9ECEF"
                                                    }}
                                                />
                                            </Box>
                                        </Card>
                                    </div>
                                </Grid>

                                <Grid item xs={12} md={4}>

                                    <CustomTextarea
                                        name="note"
                                        fieldLabel="Note"
                                        placeholder="Enter Note"
                                        value={values.note}
                                        onChange={handleChange}
                                        sx={{ height: '50px !important' }}
                                    />
                                </Grid>

                            </Grid>
                        </Form>
                    )}
                </Formik>
            </Box>
            <CustomDelete
                handleDelete={handleDelete}
                open={deleteAlert}
                rowId={rowId}
                handleClose={() => setDeleteAlert(false)}
            />
        </>
    );
};

export default UpdateExpProformInv;

const styles = {
    table: {
        minWidth: 650,
    },
    textMuted: {
        color: '#6c757d',
    },

    labelCell: {
        width: '180px',
    },
    tableContainer: {
        marginBottom: '16px',
    },
    header: {
        marginBottom: '16px',
    },
    title: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    customTableRow: {
        height: '20px',
    },
    editButton: {
        textAlign: 'right',
    },
    showDetailsSpan: {
        padding: '8px',
        fontWeight: 600,
        fontSize: '16px',
        color: '#212529',
        cursor: 'pointer',
    },
    expandIcon: {
        color: '#212529',
    },
    boxheading: {
        width: 70,  // Width of the box
        height: 70, // Height of the box, making it square
        background: 'radial-gradient(circle, #007BFF 0, rgba(0, 134, 201, .5) 0, #007BFF 100%)', // Radial gradient background
        color: 'white', // Text color
        display: 'flex', // Center content horizontally
        alignItems: 'center', // Center content vertically
        justifyContent: 'center', // Center content horizontally
        borderRadius: 14, // Rounded corners
        boxShadow: 3, // Box shadow for depth
    },
    headingname: {
        paddingTop: '10px',
        fontWeight: '600',
        fontSize: '20px',
        color: '#212529',
    },
    avatarcircle: {
        backgroundColor: '#007BFF',
        width: '30px',
        height: '30px',
        fontSize: '15px',
    },
    cardtittile: {
        padding: '8px',
        paddingLeft: '35px',
        fontWeight: 600,
        fontSize: '16px',
        color: '#212529',
    },
    tablebutton: {
        backgroundColor: '#007bff',
        color: '#ffff',
        textTransform: 'capitalize',
        borderRadius: 4,
        border: '2px solid #007bff',
        height: 30,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    tablecell: {
        border: '1px solid #dee2e6',
        color: '#212529',
        fontWeight: 600,
        fontSize: '14px',
        textAlign: 'center',
        padding: '1px',
        paddingLeft: "10px",
        paddingRight: "10px",
    },
    tablecellfooter: {
        border: '1px solid #dee2e6',
        color: '#212529',
        fontWeight: 600,
        fontSize: '14px',
        textAlign: 'right',
        padding: '1px',
        paddingLeft: "10px",
        paddingRight: "10px",
    },

};


const Additemstyle = {
    color: '#212529 !important',
    textTransform: 'capitalize !important',
    borderRadius: '4px !important',
    border: '1px dashed #aecce4 !important',
    height: '30px !important',
    display: 'inline-flex !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    backgroundColor: '#e7f0f7 !important',
    width: '100% !important',
};
